import React, { Component } from "react";
import { Link } from 'react-router-dom';
import { FiX , FiMenu } from "react-icons/fi";


class Header extends Component{
    constructor(props) {
        super(props);
        this.menuTrigger = this.menuTrigger.bind(this);
        this.CLoseMenuTrigger = this.CLoseMenuTrigger.bind(this);
       //  this.subMetuTrigger = this.subMetuTrigger.bind(this);
        window.addEventListener('load', function() {
            console.log('All assets are loaded')
        })
    }

    menuTrigger() {
        document.querySelector('.header-wrapper').classList.toggle('menu-open')
    }

    CLoseMenuTrigger() {
        document.querySelector('.header-wrapper').classList.remove('menu-open');
    }


    render(){
        var elements = document.querySelectorAll('.has-droupdown > a');
        for(var i in elements) {
            if(elements.hasOwnProperty(i)) {
                elements[i].onclick = function() {
                    this.parentElement.querySelector('.submenu').classList.toggle("active");
                    this.classList.toggle("open");
                }
            }
        }
        const { logo, color='default-color' } = this.props;
        let logoUrl;
        if(logo === 'light'){
            logoUrl = <img src="/assets/images/logo/logo-white.png" height="50rem" alt="Coach DOI" />;
        }else if(logo === 'dark'){
            logoUrl = <img src="/assets/images/logo/logo-black.png" height="50rem" alt="Coach DOI" />;
        }else if(logo === 'symbol-dark'){
            logoUrl = <img src="/assets/images/logo/logo-black.png" height="50rem" alt="Coach DOI" />;
        }else if(logo === 'symbol-light'){
            logoUrl = <img src="/assets/images/logo/logo-white.png" height="50rem" alt="Coach DOI" />;
        }else{
            logoUrl = <img src="/assets/images/logo/logo-white.png" height="50rem" alt="Coach DOI" />;
        }
        
        return(
            <header className={`header-area formobile-menu header--transparent ${color}`}>
                <div className="header-wrapper" id="header-wrapper">
                    <div className="header-left">
                        <div className="logo">
                            <a href="/">
                                {logoUrl}
                            </a>
                        </div>
                    </div>
                    <div className="header-right">
                        <nav className="mainmenunav d-lg-block">
                            <ul className="mainmenu">
                                <li><a href="/">Home</a></li>
                                <li><a href="/about">About</a></li>
                                <li className="has-droupdown"><a href="#" >Courses</a>
                                    <ul className="submenu">
                                        <li><a href="/resilient-professional">The Resilient Professional</a></li>
                                        <li><a href="/exploiting-your-value">Decoupling and Exploiting Your Value</a></li>
                                        <li><a href="/career-trajectory">Career Trajectory</a></li>
                                        <li><a href="/value-driven-leader">The Value-Driven Leader</a></li>
                                    </ul>
                                </li>
                                <li className="has-droupdown"><a href="#" >Coaching</a>
                                    <ul className="submenu">
                                        <li><a href="/pmmp">Project Management Mentorship Program</a></li>
                                        <li><a href="/change-leadership">Change Leadership</a></li>
                                        <li><a href="/business-transformation-catalyst">Business Transformation Catalyst</a></li>
                                    </ul>
                                </li>
                                <li className="has-droupdown"><a href="#">Portfolio</a>
                                    <ul className="submenu">
                                        <li><a href="/stumbling-towards-clarity">Stumbling Towards Clarity</a></li>
                                    </ul>
                                </li>
                                <li><a href="/contact">Contact</a></li>
                            </ul>
                        </nav>
                        {/* <div className="header-btn">
                            <a className="rn-btn" href="/#contact">
                                <span>get started</span>
                            </a>
                        </div> */}
                        {/* Start Humberger Menu  */}
                        <div className="humberger-menu d-block d-lg-none pl--20">
                            <span onClick={this.menuTrigger} className="menutrigger text-white"><FiMenu /></span>
                        </div>
                        {/* End Humberger Menu  */}
                        <div className="close-menu d-block d-lg-none">
                            <span onClick={this.CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
                        </div>
                    </div>
                </div>
            </header>
        )
    }
}
export default Header;